import React from 'react'
import { isFragment } from 'react-is'
import styled from 'styled-components'
import ArrowRight from '../../atoms/Icons/Button/ArrowRight'
import StoreSvg from '../../atoms/Icons/General/Store'
import Breakpoints from '../../theme/breakpoints'

const Separator = styled.div`
  display: inline;
  line-height: 0;
  margin: 0 8px 0 8px;
`

const Container = styled.nav`
  display: flex;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  overflow: hidden;
  min-height: 33px;
  margin-bottom: 32px;

  * {
    font-size: 14px;
  }
`

const Item = styled.li`
  list-style: none; 
  display: inline-flex;
  align-items: center;
  height: 24px;
  display: contents;
  flex-align: center;

  .mobile-content {
    display: none; 
  }

  .desktop-content {
    display: block; 
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  @media (max-width: ${Breakpoints.tablet}) {
    .desktop-content {
      display: none;
    }
    
    .mobile-content { 
      display: block; 
    }

    &:nth-of-type(3) .mobile-content {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  * { font-size: 14px; }

  @media (max-width: ${Breakpoints.tablet}) {
    * { font-size: 12px; }
  }
`

const Breadcrumbs = ({ children }) => {
  const childrenArray = React.Children.toArray(children)
  const list = childrenArray
    .filter(child => {
      if (!child) return false
      if (isFragment(child)) return false
      return true
    })
    .map((child, index) => {
      const Icon = index === 0 ? '' : <ArrowRight height={12} width={12} />
      let mobileContent = null
      if (index === 0) {
        mobileContent = <StoreSvg />
      } else if (index === 1) {
        mobileContent = '...'
      } else {
        mobileContent = child
      }

      return (
        <Item key={index} className={`${index}`}>
          {Icon && <Separator >{Icon}</Separator>}
          <div className='mobile-content'>{mobileContent}</div>
          <div className='desktop-content'>{child}</div>
        </Item>
      )
    })

    return <Container>
      {list}
    </Container>
}

export default Breadcrumbs
